import { render, staticRenderFns } from "./manageDetail.vue?vue&type=template&id=7430524f"
import script from "./manageDetail.vue?vue&type=script&lang=js"
export * from "./manageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports